import bioPhoto1 from "@assets/images/banner/1.jpg?format=webp&w=512&imagetools";
import bioPhoto2 from "@assets/images/banner/2.jpg?format=webp&w=512&imagetools";
import carousel1 from "@assets/images/carousel-images/1.jpg?format=webp&w=1260&imagetools";
import carousel2 from "@assets/images/carousel-images/2.jpg?format=webp&w=1260&imagetools";
import carousel3 from "@assets/images/carousel-images/3.jpg?format=webp&w=1260&imagetools";
import carousel4 from "@assets/images/carousel-images/web_headspa-2.jpg?format=webp&w=1260&imagetools";
import carousel5 from "@assets/images/carousel-images/web_headspa-42.jpg?format=webp&w=1260&imagetools";
import carousel6 from "@assets/images/carousel-images/web_headspa-48.jpg?format=webp&w=1260&imagetools";
import carousel7 from "@assets/images/carousel-images/web_headspa-59.jpg?format=webp&w=1260&imagetools";
import carousel8 from "@assets/images/carousel-images/web_headspa-60.jpg?format=webp&w=1260&imagetools";
import carousel9 from "@assets/images/carousel-images/web_headspa-61.jpg?format=webp&w=1260&imagetools";
import carousel10 from "@assets/images/carousel-images/web_headspa-62.jpg?format=webp&w=1260&imagetools";
import carousel11 from "@assets/images/carousel-images/web_headspa-63.jpg?format=webp&w=1260&imagetools";
import carousel12 from "@assets/images/carousel-images/web_headspa-64.jpg?format=webp&w=1260&imagetools";
import carousel13 from "@assets/images/carousel-images/web_headspa-65.jpg?format=webp&w=1260&imagetools";
import carousel14 from "@assets/images/carousel-images/web_headspa-66.jpg?format=webp&w=1260&imagetools";
import carousel15 from "@assets/images/carousel-images/web_headspa-67.jpg?format=webp&w=1260&imagetools";
import carousel16 from "@assets/images/carousel-images/web_headspa-68.jpg?format=webp&w=1260&imagetools";
import carousel17 from "@assets/images/carousel-images/web_headspa-69.jpg?format=webp&w=1260&imagetools";
import carousel18 from "@assets/images/carousel-images/web_headspa-70.jpg?format=webp&w=1260&imagetools";
import procedure1 from "@assets/images/procedures/1.jpg?format=webp&w=776&imagetools";
import step1Mobile from "@assets/images/steps/1.jpg?format=webp&w=341&imagetools";
import step1Desktop from "@assets/images/steps/1.jpg?format=webp&w=598&imagetools";
import step2Mobile from "@assets/images/steps/2.jpg?format=webp&w=341&imagetools";
import step2Desktop from "@assets/images/steps/2.jpg?format=webp&w=598&imagetools";
import step3Mobile from "@assets/images/steps/3.jpg?format=webp&w=341&imagetools";
import step3Desktop from "@assets/images/steps/3.jpg?format=webp&w=598&imagetools";

export const homepageImages = {
	"step-1": { mobile: step1Mobile, desktop: step1Desktop },
	"step-2": { mobile: step2Mobile, desktop: step2Desktop },
	"step-3": { mobile: step3Mobile, desktop: step3Desktop },
	"carousel-1": carousel1,
	"carousel-2": carousel2,
	"carousel-3": carousel3,
	"carousel-4": carousel4,
	"carousel-5": carousel5,
	"carousel-6": carousel6,
	"carousel-7": carousel7,
	"carousel-8": carousel8,
	"carousel-9": carousel9,
	"carousel-10": carousel10,
	"carousel-11": carousel11,
	"carousel-12": carousel12,
	"carousel-13": carousel13,
	"carousel-14": carousel14,
	"carousel-15": carousel15,
	"carousel-16": carousel16,
	"carousel-17": carousel17,
	"carousel-18": carousel18,
	"procedure-1": procedure1,
	"bio-1": bioPhoto1,
	"bio-2": bioPhoto2,
} as const;

export type HomepageImageKey = keyof typeof homepageImages;
